import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { FaSpinner } from 'react-icons/fa';
import Button from '@material-ui/core/Button';
import { Toast } from 'primereact/toast';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/impressao-pedido-internacao.css';

export default function ImpressaoPedidoInternacao({ pedido, closeDialog, listarPedidosCirurgia }) {
  const [carregarSubmit, setCarregarSubmit] = useState(false);
  const [toast, setToast] = useState(null);

  const showWarn = (msg, severity) => {
    toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 3000,
    });
  };

  // Gravar data da impressão e depois abrir impressão
  async function handleGravarDataImpressaoPedidoInternacao() {
    await dominioDemandaCirurgica.get(`/api/pedidoCirurgia/${pedido.id}`).then(response => {
      const {
        principaisSinaisSintomas,
        principaisResultadosProvasDiagnosticas,
        recursosNecessariosAtendimentoPaciente,
        historiaClinica,
        equipePrestadora,
        areaMedica,
        profissionalRequisitante,
      } = response.data;

      const { profissional_id } = JSON.parse(localStorage.getItem('profissional'));

      const data = {
        principaisSinaisSintomas,
        principaisResultadosProvasDiagnosticas,
        recursosNecessariosAtendimentoPaciente,
        historiaClinica,
        crm: profissionalRequisitante ? profissionalRequisitante.crm : undefined,
        equipePrestadora: equipePrestadora?.id,
        areaMedica: areaMedica?.id,
      };

      dominioDemandaCirurgica
        .put(`/api/dadosImpressaoPedidoInternacao/${pedido.id}/${profissional_id}`, data)
        .then(
          async () => {
            await dominioDemandaCirurgica().then(promise => {
              window.open(`${promise.config.baseURL}/pedidoInternacao/${pedido.id}`);
            });

            setCarregarSubmit(false);
            closeDialog();
            document.location.reload(true);
          },
          () => {
            setCarregarSubmit(false);
            showWarn('Erro ao imprimir!', 'warn');
          }
        );
    });
  }

  useEffect(() => {
    if (!pedido.dataImpressaoPedidoInternacao) {
      handleGravarDataImpressaoPedidoInternacao();
    }
  }, []);

  // Abrir impressão caso tiver já tiver sido impresso
  const handleSubmit = e => {
    e.preventDefault();

    setCarregarSubmit(true);

    dominioDemandaCirurgica().then(promise => {
      window.open(`${promise.config.baseURL}/pedidoInternacao/${pedido.id}`);
      setCarregarSubmit(false);
      closeDialog();
      // document.location.reload(true);
    });
  };

  return (
    <>
      {pedido.dataImpressaoPedidoInternacao && (
        <Container className="container-pedido-internacao">
          <Toast
            ref={el => {
              setToast(el);
            }}
            position="top-right"
          />
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <strong className="confirmacao-de-reimpressao">
                Este documento já foi impresso. <br />
                Tem certeza de que deseja reimprimi-lo?
              </strong>

              <Grid item xs={12} sm={12}>
                <div className="div-botoes">
                  <Button type="submit" variant="contained" color="primary">
                    {carregarSubmit ? (
                      <FaSpinner color="#FFF" className="loading" size={14} />
                    ) : (
                      <> Imprimir </>
                    )}
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    onClick={() => closeDialog()}
                  >
                    Cancelar
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        </Container>
      )}
    </>
  );
}
